/*
 * ██████╗ ██╗████████╗███████╗ █████╗  ██████╗████████╗ ██████╗ ██████╗ ██╗   ██╗
 * ██╔══██╗██║╚══██╔══╝██╔════╝██╔══██╗██╔════╝╚══██╔══╝██╔═══██╗██╔══██╗╚██╗ ██╔╝
 * ██████╔╝██║   ██║   █████╗  ███████║██║        ██║   ██║   ██║██████╔╝ ╚████╔╝
 * ██╔══██╗██║   ██║   ██╔══╝  ██╔══██║██║        ██║   ██║   ██║██╔══██╗  ╚██╔╝
 * ██████╔╝██║   ██║   ██║     ██║  ██║╚██████╗   ██║   ╚██████╔╝██║  ██║   ██║
 * ╚═════╝ ╚═╝   ╚═╝   ╚═╝     ╚═╝  ╚═╝ ╚═════╝   ╚═╝    ╚═════╝ ╚═╝  ╚═╝   ╚═╝
 *
 *
 * Copyright (c) Bitfactory GmbH. All rights reserved.
 * https://www.bitfactory.io
 *
 * Redistribution and use in source and binary forms, with or without
 * modification, are not permitted.
 *
 * THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS
 * "AS IS" AND ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT
 * LIMITED TO, THE IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS
 * FOR A PARTICULAR PURPOSE ARE DISCLAIMED. IN NO EVENT SHALL THE
 * COPYRIGHT OWNER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT, INDIRECT,
 * INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES INCLUDING,
 * BUT NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES;
 * LOSS OF USE, DATA, OR PROFITS; OR BUSINESS INTERRUPTION) HOWEVER
 * CAUSED AND ON ANY THEORY OF LIABILITY, WHETHER IN CONTRACT, STRICT
 * LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE) ARISING IN
 * ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE
 * POSSIBILITY OF SUCH DAMAGE.
 */

import React, { ReactElement } from 'react';
import { Container, Grid, Typography, GridLegacy } from '@mui/material';
import CreateCourseView from './CreateCourse/CreateCourseView';
import CourseView from './Course/CoursesView';
import { FormattedMessage } from 'react-intl';
import { useViewModel } from '../../../hooks/useViewModel';
import { CoursesOverviewViewModel } from './CoursesOverviewViewModel';
import { observer } from 'mobx-react';
import { autorun } from 'mobx';
import { Course } from '../../../types/course/Course';

const CoursesOverviewView = observer((): ReactElement => {
	const viewModel: CoursesOverviewViewModel = useViewModel(CoursesOverviewViewModel);

	autorun(() => {
		viewModel.subscribeToCourseEvents().forEach(() => {
			viewModel.queryCourses();
		});
	});

	return (
		<Container sx={{ marginTop: '32px' }}>
			<Typography variant={'h1'}>
				<FormattedMessage id='courses.title' />
			</Typography>
			<GridLegacy container marginTop='24px' spacing={2}>
				<GridLegacy item lg={2} md={2} sm={4} xs={6}>
					<CreateCourseView />
				</GridLegacy>
				{viewModel.getCourses().map((course: Course) => {
					return (
						<GridLegacy key={course.courseId} item lg={2} md={2} sm={4} xs={6}>
							<CourseView course={course} />
						</GridLegacy>
					);
				})}
			</GridLegacy>
		</Container>
	);
});

export default CoursesOverviewView;
